@if ((assignedApplications()?.length??0)>0) {
@for (appSelection of assignedApplications(); track appSelection.id) {
<div class="heka-app-list-item-container mb-3">
  <div class="logo">
    <ngx-heka-application-img [applicationId]="appSelection.id" />
  </div>
  <div class="d-flex flex-column">
    <span class="text-color-black">{{ ((appSelection.id |appTranslationKeys)?.translationTitle || '') |translate
      }}</span>
    <span class="sub-line">{{ ((appSelection.id |appTranslationKeys)?.translationContent || '') |translate }}</span>
  </div>
</div>
}
} @else {
-
}